//idcard脱敏
export  const idCardChange = (value) =>{
    if(value){
        return value.replace(/(\w{6})\w*(\w{4})/, '$1********$2')
    }else{
        return '--'
    }  
}

//mobile脱敏
export const mobile = (value) =>{
    if(value){
        return value.replace(/(\w{3})\w*(\w{4})/,'$1****$2')
    }else{
        return '--'
    }
}

//时间
export const dateTime = (value,index) =>{
    if(value && value !== '0' && value != '86430'){
        var date = new Date(value*1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
        var D = date.getDate() < 10 ? '0'+date.getDate() : date.getDate() 
        if(index){
            var h = ' '+(date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':'
            var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':'
            var s = date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds()
            return Y+M+D+h+m+s
        }else{
            return Y+M+D
        }
    }else{
        return '--'
    }
}

//小数点
export const numFilter = (value,index) => {
    // 截取当前数据到小数点后三位
    let i = parseInt(index)
    let tempVal = parseFloat(value).toFixed(i)
    let realVal = tempVal.substring(0,  tempVal.length - 1)
    return realVal
}

//银行卡号
export  const BankCard = (value) =>{
    if(value){
        return value.replace(/(\w{6})\w*(\w{4})/, '$1********$2')
    }else{
        return '--'
    }  
}

//居住地址
export  const AddRess = (value) =>{
    if(typeof value == 'string' && value != ''){
        let ruten = value.substring(6);
        return value.replace(ruten,'************');
    } else {
        return '--'
    }
}

//姓名提取
export  const CaseName = (value) =>{
    if(typeof value == 'string'){
        let ruten = value.substring(1);
        return value.replace(ruten,'**');
    }
}

//性别提取
export const distillSex = (value) => {   
    let res = '';
    let len = 0;
    if (value != '' && value != undefined) {
        len = value.length;
        if (len == 15) {
            res = value.substring(14,15)
        } else {
            res = value.substring(16,17)
        }
    }           
    return res % 2 == 0 ? '女' : '男';
}

//委托方转中文
export  const EntrustsNo = (value) =>{
    let Entrusts = JSON.parse(sessionStorage.getItem('entrustsAll'));
    for (var key in Entrusts) {
        if (value == Entrusts[key]['id']) {
            return Entrusts[key]['name'];
        }
    }
}

//金额万位制
export const Money = (value) =>{
    if(value){
        return (value / 10000).toFixed(2)
    }else{
        return 0
    }
}

//金额每隔三位加逗号
export const toThousands = (num) =>{
    var result = '', counter = 0;
    var dot = String(num).indexOf(".");
    if(dot != -1){  //有小数点
        // 获取小数点后面的数字(indexOf和substring都不支持数字，所以要先转字符串才可以用)
        var dotCnt = String(num).substring(dot+1,num.length);
        // 获取小数点前面的数字
        num = String(num).split('.')[0]
        num = (num || 0).toString();
        for (var i = num.length - 1; i >= 0; i--) {
            counter++;
            result = num.charAt(i) + result;
            if (!(counter % 3) && i != 0) { result = ',' + result; }
        }
        result = result + '.' + dotCnt;
    }else{  //没有小数点
        result = (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    }
    result = result.replace(/^\-\,/g,'-'); //负数
    return result
}

//秒转换成时分秒
export const MinutesChange = (val, type = 'c') => {
    let time = Number(val)
    if (isNaN(time)) {
        return
    }
    let h, m, s;
    if (time > 60) {
        m = parseInt(time/60)
        s = time%60
        if (m > 60) {
            h = parseInt(m/60)
            m = m%60
        }
        if (type !== 'c') {
            h = h > 0 ? (h > 9 ? h + ':' : `0${h}:`) : '00:';
            m = m > 0 ? (m > 9 ? m + ':' : `0${m}:`) : '00:';
            s = s > 0 ? (s > 9 ? s : `0${s}`) : '00';
        } else {
            h = h > 0 ? h + '时' : '';
            m = m > 0 ? m + '分' : (s > 0 ? '0分' : '');
            s =  s > 0 ? s + '秒' : '';
        }
            
        return h+m+s
    } else if (time <= 0) {
        if (type !== 'c') {
            return '00:00:00'
        }
        return 0
    } else {
        if (type !== 'c') {
            return '00:00:' + (time > 9 ? time : `0${time}`)
        }
        return time + '秒'
    }
}


// WEBPACK FOOTER //
// ./src/api/filter.js